import Hashids from "hashids/cjs";

interface SeedsInterface {
    place: string;
    displayVacancy: string;
    coupon: string;
    sensor: string;
    gateway: string;
    tablet: string;
    user: string;
    alertDestination: string;
}
type Type = keyof SeedsInterface;

export class HashUtil {
    private type: Type;
    private seeds: SeedsInterface = {
        place: "place/placeId",
        coupon: "place/coupon",
        displayVacancy: "view/displayVacancyId",
        sensor: "device/sensorId",
        gateway: "device/gatewayId",
        tablet: "device/tabletId",
        user: "user/userId",
        alertDestination: "alert/alertDestinationId",
    };
    private hashDigits = 16;

    constructor(type: Type) {
        this.type = type;
    }

    public hashFromId(id: number): string {
        const hashids = new Hashids(this.seeds[this.type], this.hashDigits);
        return hashids.encode(id);
    }

    public idFromHash(hash: string): number {
        const hashids = new Hashids(this.seeds[this.type], this.hashDigits);
        return Number(hashids.decode(hash).shift()) | 0;
    }
}
